function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'funnels-conversion-over-time-chart': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.hasNoData()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("slot", {
            "attrs": __vjadeStringifyAttrsIfObj({
              name: `empty-state`
            }),
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-legend-line-chart", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'display-analysis-type': `linear`,
              'display-context': $attr(`display-context`),
              'incomplete-from-date': $attr(`incomplete-from-date`),
              'incomplete-to-date': $attr(`incomplete-to-date`),
              'is-compact': $attr(`is-compact`),
              'legend-sections': JSON.stringify($helpers.getLegendSections()),
              'legend-theme': $attr(`legend-theme`),
              'show-annotations': $attr('show-annotations'),
              'trend-unit': $helpers.getTrendUnit(),
              'x-axis-options': $helpers.getXAxisOptions(),
            }),
            "props": {
              chartData: $helpers.getChartData(),
              formatXAxisLabel: $helpers.formatXAxisLabel,
              formatYAxisLabel: $helpers.formatYAxisLabel,
              formatTooltip: $helpers.formatTooltip,
            },
            "on": {
              togglecheckbox: $helpers.passThrough
            },
          }));
          __jade_nodes = __jade_nodes.concat((!$attr(`download-mode`) && !$attr(`hide-analysis-button`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-oda-control", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'description': `Receive an email of statistically significant segments impacting this funnel.`,
                'is-waiting-for-schedule-analysis': this.attr(`is-waiting-for-schedule-analysis`),
                'show-upsell': this.attr(`show-on-demand-analysis-upsell`),
                'upsell-description': $helpers.ODA_FUNNELS_UPSELL_DESCRIPTION,
              }),
              "on": {
                clickAnalyze: this.helpers.clickAnalyze
              },
              "class": {
                'oda-control': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;